import React from 'react';
import Segmenter from './components/Segmenter.tsx';

const App: React.FC = () => {
  return <Segmenter />;
};

export default App;
